import {ApiResponse} from './Response'
import axios from 'axios'
import {toast} from 'react-toastify'

export function apiGetAlimtalk(): Promise<ApiResponse> {
  return axios.get(`${process.env.REACT_APP_API2_URL}am/alimtalk`).then((res): Promise<ApiResponse> => {
    if (res.data.error === '') {
      return res.data
    } else if (res.data.error !== '') {
      toast.error(res.data.error)
    }
    throw new Error('Server Error')
  }).catch(error => {
    throw error
  })
}
